export default "__VITE_ASSET__9jd5siKe__"